import CustomerLayout from "./customerLayout";
import Complete1 from "assets/morning/complete1.png";
import Complete2 from "assets/morning/complete2.png";
import Button from "../../-components/common/Button";
import { useLocation, useNavigate } from "react-router-dom";
import PrintTracking from "../../-components/PrintTracking";
import { useState } from "react";

const MorningCompleteAdd = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const resData = location.state?.data[0];

    const [trackingPop, setTrackingPop] = useState<boolean>(false);

    return (
        <CustomerLayout>
            <div className="bg-[#f8f8f8] flex flex-col items-center pt-12 p-5">
                <p className="text-[#1b1c1e] text-[37px] font-bold">인터넷오더접수</p>
                <div className="mt-10 w-full max-w-[560px] flex flex-col gap-2 bg-[#feeee5] border border-new rounded-2xl py-4 px-5 text-[#1b1c1e]">
                    <p className="text-center font-[500] text-lg">오더접수가 완료되었습니다!</p>
                    <div>
                        <p>※ 오더취소시 물품픽업전에 가능하오니</p>
                        <p className="pl-4">"운송장조회"에서 넘버조회 후 취소해주세요.</p>
                    </div>
                    <div className="flex gap-3 items-center">
                        <img src={Complete1} alt="Complete" />
                        <p>작성한 오더접수는 실시간 운송장 조회 내역에서 확인 가능합니다.</p>
                    </div>
                    <div className="flex gap-3 items-center">
                        <img src={Complete2} alt="Complete" />
                        <p>보내실 물품 포장 후 운송장을 출력하여 부착해주세요.</p>
                    </div>
                </div>
                <div className="w-full max-w-[560px] bg-white pt-6 pb-3 px-10 mt-3 rounded-2xl">
                    <p className="text-[#1b1c1e] border-b-2 border-[#1b1c1e] pb-2.5 mb-7 text-[28px] font-bold">접수상세</p>
                    <div className="flex flex-col gap-1">
                        <div className="flex items-start min-h-[38px]">
                            <p className={`text-[18px] font-[500] min-w-[160px] text-[#878A93]`}>송장번호</p>
                            <div className="flex flex-col gap-1">
                                {resData?.bl_no.map((item: any, index: number) => <div key={index}>{item}</div>)}
                            </div>
                        </div>
                        <div className="flex items-center h-[52px]">
                            <p className={`text-[18px] font-[500] min-w-[160px] text-[#878A93]`}>상호명</p>
                            <p className={`text-[18px] w-full`}>{resData.a_company}</p>
                        </div>
                        <div className="flex items-center h-[52px]">
                            <p className={`text-[18px] font-[500] min-w-[160px] text-[#878A93]`}>총 수량</p>
                            <p className={`text-[18px] w-full`}>{resData.totalCnt} 건</p>
                        </div>
                    </div>
                </div>
                <div className="w-full max-w-[560px] flex flex-col gap-2 mt-10 mb-20">
                    <Button onClick={() => setTrackingPop(true)} className="bg-new text-white border-none w-full" size="L">
                        전체 운송장 다운로드 및 출력
                    </Button>
                    <Button onClick={() => navigate("/customer/online-order")} className="bg-white border-black text-black w-full" size="L">
                        추가 오더접수
                    </Button>
                    <Button onClick={() => navigate("/customer/tracking")} className="bg-white border-black text-black w-full" size="L">
                        운송장 내역 바로가기
                    </Button>
                    <Button
                        onClick={() => {
                            window.open("https://intriguing-dryer-881.notion.site/120a61a48d338056bbffe26a2216aecb", "_blank");
                        }}
                        className="border-new text-new underline w-full flex items-center gap-3"
                        size="L"
                    >
                        <span className="w-0 h-0 border-t-[7px] border-b-[7px] border-l-[10px] border-t-transparent border-b-transparent border-l-current text-new" />
                        프린트 설정 가이드 (보기)
                    </Button>
                </div>
            </div>
            {trackingPop && (
                <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                    <PrintTracking onClose={() => setTrackingPop(false)} bl_no={resData?.bl_no} />
                </div>
            )}
        </CustomerLayout>
    );
};
export default MorningCompleteAdd;
